var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isSetParam, } from './EquipmentServiceDriver';
import { convertNumber } from './ParamBridge';
import { StateCollection } from './State';
import { ConfigKeyedValueBridge, KeyedValueBridge, ParameterlessBridge } from './ValueBridge';
export class ShadeOperationBridge extends ConfigKeyedValueBridge {
    constructor(control, config, controlInfo, powerState, transport, valueCallback, log) {
        super('shadeOperation', new StateCollection(), // dummy
        control, 'shadeControls', config, controlInfo, powerState, transport, valueCallback, log);
    }
    convertFromParam(value) {
        return {
            key: value.shadeControlId,
            value,
        };
    }
    convertToParam(key, value) {
        return Object.assign(Object.assign({}, value), { shadeControlId: key });
    }
    getInfo(config) {
        return undefined;
    }
}
export class ShadeOperationsBridge extends ParameterlessBridge {
    constructor(state, control, getKeyMap, controlInfo, powerState, transport, log) {
        super('shadeOperations', state, control, controlInfo, powerState, transport, log);
        this.getKeyMap = getKeyMap;
    }
    getEquipmentOperations() {
        var _a;
        const keyMap = this.getKeyMap();
        const eqMap = {};
        for (const [dKey, ops] of Object.entries(this.state.value)) {
            const eKey = (_a = Object.entries(keyMap).find(e => e[1] === dKey)) === null || _a === void 0 ? void 0 : _a[0];
            if (eKey === undefined) {
                this.log.error(`shadeOperationsBridge: no equipment key for driver key ${dKey}`);
                continue;
            }
            eqMap[eKey] = [...ops];
        }
        return eqMap;
    }
}
export class ShadePositionBridge extends KeyedValueBridge {
    constructor(state, rangesState, control, driverConfig, getKeyMap, controlInfo, powerState, transport, valueCallback, log) {
        super('shadePosition', state, control, () => Object.values(this.getKeyMap()), controlInfo, powerState, transport, valueCallback, log);
        this.rangesState = rangesState;
        this.driverConfig = driverConfig;
        this.getKeyMap = getKeyMap;
        if (isSetParam(this.name))
            this.setFilters[this.name] = this.setFilter.bind(this);
        this.rangesStateSubscription = this.rangesState.subscribe((key, prevValue) => {
            const prevLevel = prevValue === undefined
                ? undefined
                : convertNumber(this.state.values[key], prevValue.max, prevValue.min, 100, 0, 1);
            const newLevel = convertNumber(this.state.values[key], this.rangesState.values[key].max, this.rangesState.values[key].min, 100, 0, 1);
            if (newLevel !== prevLevel) {
                this.valueCallback('shadePosition', {
                    lightingControlId: key,
                    value: newLevel,
                });
            }
        });
    }
    convertFromParam(value) {
        const fromValue = value.value;
        const key = this.getKeyMap()[value.shadeControlId];
        if (key === undefined) {
            throw new Error(`no shadePosition driver key for equipment key = ${value.shadeControlId}`);
        }
        const range = this.rangesState.values[key];
        if (range === undefined) {
            throw new Error(`range undefined for key: ${key}`);
        }
        const convertedValue = convertNumber(fromValue, 100, 0, range.max, range.min, range.round);
        return { key, value: convertedValue };
    }
    convertToParam(key, value) {
        var _a;
        const range = this.rangesState.values[key];
        if (range === undefined) {
            throw new Error(`range undefined for key: ${key}`);
        }
        const convertedValue = convertNumber(value, range.max, range.min, 100, 0, 1);
        const shadeControlId = (_a = Object.entries(this.getKeyMap()).find(m => m[1] === key)) === null || _a === void 0 ? void 0 : _a[0];
        if (shadeControlId === undefined) {
            throw new Error(`no shadePosition equipment key for driver key = ${key}`);
        }
        return { shadeControlId, value: convertedValue };
    }
    destroy() {
        this.rangesState.unsubscribe(this.rangesStateSubscription);
        super.destroy();
    }
    getInfo(config) {
        return undefined;
    }
    setFilter(param, value, compParam, compValue) {
        if (param !== compParam)
            return true;
        const shadeControlId = value.shadeControlId;
        const compShadeControlId = compValue.shadeControlId;
        return shadeControlId !== compShadeControlId;
    }
    validate() {
        return __awaiter(this, void 0, void 0, function* () {
            // This control doesn't validate anything, but we use this as an opportunity to query the
            // ranges and build a range map.
            const rc = this.control;
            const keyMap = this.getKeyMap();
            for (const dKey of Object.values(keyMap)) {
                this.rangesState.values[dKey] =
                    typeof rc.range === 'function' ? yield rc.range(dKey, this.driverConfig) : rc.range;
            }
            return undefined;
        });
    }
}
export class ShadePresetBridge extends ConfigKeyedValueBridge {
    constructor(state, control, config, controlInfo, powerState, transport, valueCallback, log) {
        super('shadePreset', state, control, 'shadePresets', config, controlInfo, powerState, transport, valueCallback, log);
        // No set filter. Run all shade presets.
    }
    convertFromParam(value) {
        return { key: value.shadePresetId, value: value.value };
    }
    convertToParam(key, value) {
        return { shadePresetId: key, value };
    }
    getInfo(config) {
        return undefined;
    }
}
export class ShadeTiltBridge extends KeyedValueBridge {
    constructor(state, rangesState, control, driverConfig, getKeyMap, controlInfo, powerState, transport, valueCallback, log) {
        super('shadeTilt', state, control, () => Object.values(this.getKeyMap()), controlInfo, powerState, transport, valueCallback, log);
        this.rangesState = rangesState;
        this.driverConfig = driverConfig;
        this.getKeyMap = getKeyMap;
        if (isSetParam(this.name))
            this.setFilters[this.name] = this.setFilter.bind(this);
        this.rangesStateSubscription = this.rangesState.subscribe((key, prevValue) => {
            const prevLevel = prevValue === undefined
                ? undefined
                : convertNumber(this.state.values[key], prevValue.max, prevValue.min, 100, 0, 1);
            const newLevel = convertNumber(this.state.values[key], this.rangesState.values[key].max, this.rangesState.values[key].min, 100, 0, 1);
            if (newLevel !== prevLevel) {
                this.valueCallback('shadePosition', {
                    lightingControlId: key,
                    value: newLevel,
                });
            }
        });
    }
    convertFromParam(value) {
        const fromValue = value.value;
        const key = this.getKeyMap()[value.shadeControlId];
        if (key === undefined) {
            throw new Error(`no shadeTilt driver key for equipment key = ${value.shadeControlId}`);
        }
        const range = this.rangesState.values[key];
        if (range === undefined) {
            throw new Error(`range undefined for key: ${key}`);
        }
        const convertedValue = convertNumber(fromValue, 100, 0, range.max, range.min, range.round);
        return { key, value: convertedValue };
    }
    convertToParam(key, value) {
        var _a;
        const range = this.rangesState.values[key];
        if (range === undefined) {
            throw new Error(`range undefined for key: ${key}`);
        }
        const convertedValue = convertNumber(value, range.max, range.min, 100, 0, 1);
        const shadeControlId = (_a = Object.entries(this.getKeyMap()).find(m => m[1] === key)) === null || _a === void 0 ? void 0 : _a[0];
        if (shadeControlId === undefined) {
            throw new Error(`no shadeTilt equipment key for driver key = ${key}`);
        }
        return { shadeControlId, value: convertedValue };
    }
    destroy() {
        this.rangesState.unsubscribe(this.rangesStateSubscription);
        super.destroy();
    }
    getInfo(config) {
        return undefined;
    }
    setFilter(param, value, compParam, compValue) {
        if (param !== compParam)
            return true;
        const shadeControlId = value.shadeControlId;
        const compShadeControlId = compValue.shadeControlId;
        return shadeControlId !== compShadeControlId;
    }
    validate() {
        return __awaiter(this, void 0, void 0, function* () {
            // This control doesn't validate anything, but we use this as an opportunity to query the
            // ranges and build a range map.
            const rc = this.control;
            const keyMap = this.getKeyMap();
            for (const dKey of Object.values(keyMap)) {
                this.rangesState.values[dKey] =
                    typeof rc.range === 'function' ? yield rc.range(dKey, this.driverConfig) : rc.range;
            }
            return undefined;
        });
    }
}
